/* START SOFTSKILLS USER COURSE */
export const START_SOFTSKILLS_USER_COURSE = "START_SOFTSKILLS_USER_COURSE"
export const START_SOFTSKILLS_USER_COURSE_SUCCESS =
  "START_SOFTSKILLS_USER_COURSE_SUCCESS"
export const START_SOFTSKILLS_USER_COURSE_CLEAN =
  "START_SOFTSKILLS_USER_COURSE_CLEAN"
export const START_SOFTSKILLS_USER_COURSE_ERROR =
  "START_SOFTSKILLS_USER_COURSE_ERROR"
